import { IBroadcastCommandModalBoxOption } from '@/interfaces';
import { broadcastService } from '..';

export const modal = {

  show: (payload: Omit<IBroadcastCommandModalBoxOption, 'isOpen'>) =>
    broadcastService
      .publish<IBroadcastCommandModalBoxOption>({
        type: 'modal',
        payload: ({
          ...payload,
          isOpen: true
        })
      }),

  hide: () =>
    broadcastService
      .publish<IBroadcastCommandModalBoxOption>({
        type: 'modal',
        payload: ({ isOpen: false })
      })

};
